import SuratJalanDeliverySubcon from '@/models/SuratJalanDeliverySubcon/SuratJalanDeliverySubcon';

export default class SuratJalanDeliverySubconFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.suratJalanNumber = '';
		this.deliveryInstructionSubconId  = '';
		this.deliveryInstructionSubconDiNumber = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.customerId  = '';
		this.customerCode = '';
		this.destinationId  = '';
		this.destinationCode = '';
		this.remarksMultiple = '';
		this.driverName = '';
		this.vehicleNumber = '';
		this.isAlreadyDeliver = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			suratJalanNumber : '0',
			deliveryInstructionSubconId : '0',
			deliveryInstructionSubconDiNumber : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			customerId : '0',
			customerCode : '0',
			destinationId : '0',
			destinationCode : '0',
			remarksMultiple : '0',
			driverName : '0',
			vehicleNumber : '0',
			isAlreadyDeliver : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}